import {
  ConfigProvider,
  Typography,
  Divider,
  Row,
  Col,
  Space,
  Layout,
  Button,
  Avatar,
  Card,
  List,
  Table,
  Radio,
  Menu,
  Collapse,
  Drawer,
  Form,
  Input,
  InputNumber,
  Checkbox,
  Select,
  Mentions,
  Dropdown,
  Tag,
  Modal,
  Skeleton,
  Empty,
  Popover,
  Tabs,
  Spin,
  Tree,
  Tooltip,
  Progress,
  DatePicker
} from 'ant-design-vue'

export default {
  install (Vue) {
    Vue.component(ConfigProvider.name, ConfigProvider)

    Vue.use(Typography)

    Vue.use(Divider)

    Vue.component(Space.name, Space)
    Vue.component(Row.name, Row)
    Vue.component(Col.name, Col)

    // 布局组件
    Vue.component(Layout.name, Layout)
    Vue.component(Layout.Header.name, Layout.Header)
    Vue.component(Layout.Content.name, Layout.Content)
    Vue.component(Layout.Sider.name, Layout.Sider)

    // 按钮
    Vue.component(Button.name, Button)
    Vue.component(Button.Group, Button)

    Vue.component(Tag.name, Tag)

    // 头像
    Vue.component(Avatar.name, Avatar)

    // 卡片
    Vue.component(Card.name, Card)

    // 列表
    Vue.use(List)

    // 表格
    Vue.component(Table.name, Table)

    // 表单相关
    Vue.use(Radio)
    Vue.component(Input.name, Input)
    Vue.component(InputNumber.name, InputNumber)
    Vue.component(Input.TextArea.name, Input.TextArea)
    Vue.component(Checkbox.name, Checkbox)
    Vue.use(Select)
    Vue.use(Mentions)
    Vue.component(Form.name, Form)
    Vue.component(Form.Item.name, Form.Item)

    // 菜单
    Vue.component(Menu.name, Menu)
    Vue.component(Menu.SubMenu.name, Menu.SubMenu)
    Vue.component(Menu.ItemGroup.name, Menu.ItemGroup)
    Vue.component(Menu.Item.name, Menu.Item)

    // 折叠面板
    Vue.component(Collapse.name, Collapse)
    Vue.component(Collapse.Panel.name, Collapse.Panel)

    Vue.component(Modal.name, Modal)
    Vue.component(Drawer.name, Drawer)
    Vue.component(Dropdown.name, Dropdown)
    Vue.component(Popover.name, Popover)
    Vue.use(Tree)

    Vue.component(Skeleton.name, Skeleton)
    Vue.use(Empty)
    Vue.use(Tabs)
    Vue.use(Spin)
    Vue.use(Tooltip)
    Vue.use(Progress).use(DatePicker)
  }
}
